// The customer visits grid keeps the legacy jQuery DataTables server-side
// protocol (POST /v2/time/cards/dynamic). This epic ships no backend changes,
// so the DataTables ajax contract is reused rather than adding a new endpoint.

export const visitsColumns = [
  { data: 'id' },
  { data: 'date' },
  { data: 'project.type' },
  { data: 'project.division.name' },
  { data: 'createdByEmail' },
  { data: 'project.name' },
]

// The legacy grid orders by the "date" column (index 1) descending.
const ORDER_COLUMN_INDEX = 1

export type VisitsRequestParams = {
  draw: number
  start: number
  length: number
}

export const buildVisitsRequestBody = ({ draw, start, length }: VisitsRequestParams): URLSearchParams => {
  const params = new URLSearchParams()
  params.set('draw', String(draw))
  params.set('start', String(start))
  params.set('length', String(length))
  params.set('search[value]', '')
  params.set('search[regex]', 'false')

  visitsColumns.forEach((column, index) => {
    params.set(`columns[${index}][data]`, column.data)
    params.set(`columns[${index}][name]`, '')
    params.set(`columns[${index}][searchable]`, 'true')
    params.set(`columns[${index}][orderable]`, 'true')
    params.set(`columns[${index}][search][value]`, '')
    params.set(`columns[${index}][search][regex]`, 'false')
  })

  params.set('order[0][column]', String(ORDER_COLUMN_INDEX))
  params.set('order[0][dir]', 'desc')

  return params
}

const projectTypeLabels: Record<number, string> = {
  0: 'Template',
  1: 'Project',
  2: 'Ticket',
  3: 'Maintenance',
}

export const projectTypeLabel = (type: number): string => projectTypeLabels[type] ?? ''
